export enum CollectNameOption {
    OPTIONAL = 'Optional',
    REQUIRED = 'Required',
}

export enum CollectCampaignTypeOption {
    ASYNC = 'ASYNC',
    LIVE = 'LIVE',
}
